import { useSelector } from "react-redux";

export const useAuth = () => {
  const auth = useSelector(({ auth }) => auth);
  return auth;
};
